import React, { createContext, useContext, useState } from 'react';
import AuthModal from '../components/auth/AuthModal';

const AuthModalContext = createContext();

export function useAuthModal() {
  return useContext(AuthModalContext);
}

export function AuthModalProvider({ children }) {
  const [state, setState] = useState({ open: false, role: 'client', onSuccess: null });

  // onSuccess : callback exécuté après connexion/inscription réussie côté
  // client (ex : rouvrir le modal de réservation sans perdre la sélection).
  function openClientAuth(onSuccess) {
    setState({ open: true, role: 'client', onSuccess: onSuccess || null });
  }
  function openGerantAuth() {
    setState({ open: true, role: 'gerant', onSuccess: null });
  }
  function close() {
    setState(s => ({ ...s, open: false }));
  }

  return (
    <AuthModalContext.Provider value={{ openClientAuth, openGerantAuth, close }}>
      {children}
      {state.open && <AuthModal role={state.role} onClose={close} onSuccess={state.onSuccess} />}
    </AuthModalContext.Provider>
  );
}
